// eslint-disable-next-line @typescript-eslint/no-explicit-any
interface MapByObjectId<T> {
  [objectId: string]: T;
}

interface MapById<T> {
  [id: string]: T;
}

interface BuilderFunc<T> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (keyGetter: KeyGetterFunc, map: MapByObjectId<T> | MapById<T>, value: any): any;
}

interface KeyGetterFunc {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (value: any): any;
}

function listToMapBy<T>(
  list: T[],
  keyGetter: KeyGetterFunc,
  builder: BuilderFunc<T>,
): MapByObjectId<T> | MapById<T> {
  return list.reduce((map, obj) => {
    return {
      ...map,
      [keyGetter(obj)]: builder(keyGetter, map, obj),
    };
  }, {});
}

function listToMapByObjectId<T extends HasObjectId>(list: T[]): MapByObjectId<T> {
  return listToMapBy<T>(
    list,
    (obj: T) => obj.objectId,
    (_0, _1, obj) => obj,
  );
}

function listToMapById<T extends HasId>(list: T[]): MapById<T> {
  return listToMapBy(
    list,
    (obj: T) => obj.id,
    (_0, _1, obj) => obj,
  );
}

function listToMapByGetterWithList<T extends HasObjectId>(
  list: T[],
  getter: KeyGetterFunc,
): MapById<T> {
  return listToMapBy(list, getter, (keyGetter, map, obj) => [
    // TODO: The compiler has no idea what's happening here but we'll have to trust it works
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ...((map[keyGetter(obj)] || []) as any),
    obj.objectId,
  ]);
}

function listToMapByIdGetterWithList<T extends HasId>(
  list: T[],
  getter: KeyGetterFunc,
): MapByObjectId<T> {
  return listToMapBy(list, getter, (keyGetter, map, obj) => [
    // TODO: The compiler has no idea what's happening here but we'll have to trust it works
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ...((map[keyGetter(obj)] || []) as any),
    obj.id,
  ]);
}
function shuffle<T>(list: T[]): T[] {
  return list.reduce(
    ({ originalList, shuffledList }: { originalList: T[]; shuffledList: T[] }) => {
      shuffledList.push(originalList.splice(Math.floor(Math.random() * originalList.length), 1)[0]);
      return { originalList, shuffledList };
    },
    { originalList: [...list], shuffledList: [] },
  )['shuffledList'];
}

export {
  listToMapByObjectId,
  listToMapBy,
  listToMapByGetterWithList,
  listToMapById,
  listToMapByIdGetterWithList,
  shuffle,
};
